<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>发票信息列表
      <v-spacer />
      <v-btn v-if="editable" color="primary" @click="onAdd">新增</v-btn>
    </v-card-title>
    <v-card-text v-if="!loading">
      <v-row v-if="!dataList.length" justify="center">
        <v-col cols="auto" class="orange--text text-h4 mt-8">暂无数据</v-col>
      </v-row>
      <v-expansion-panels v-else tile>
        <v-expansion-panel v-for="row in dataList" :key="row.id">
          <v-expansion-panel-header :color="row.defaultFlag ? '#81D4FA' : '#FAFAFA'">
            <v-row dense no-gutters>
              <v-col cols="10">
                <v-icon v-if="row.defaultFlag" small class="mr-2">mdi-map-marker</v-icon>
                {{row.unitName}}
              </v-col>
              <v-col v-if="!editable" cols="2" class="text-right pr-2">
                <v-btn x-small color="primary" @click="$emit('choose',row)">使用</v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <invoice-detail :form-data="row" />
            <v-row v-if="editable" justify="end">
              <v-col cols="auto">
                <v-btn v-if="!row.defaultFlag" small color="primary" @click="onSetDefault(row)">设为默认</v-btn>
                <v-btn small color="primary" class="ml-2" @click="onEdit(row)">修改</v-btn>
                <v-btn small color="red" dark class="ml-2" @click="onDelete(row)">删除</v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>

    <v-dialog v-if="editFlag" v-model="editFlag" max-width="650" scrollable>
      <v-card min-height="350" color="#FAFAFA">
        <v-card-title>
          <div>{{editFormData.id ? '修改发票信息':'新增发票信息'}}</div>
          <v-spacer />
          <v-btn icon @click="editFlag=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="editForm">
            <v-card outlined>
              <v-card-subtitle>发票信息</v-card-subtitle>
              <v-card-text>
                <v-text-field dense label="企业名称" outlined :rules="rules" v-model="editFormData.unitName" />
                <v-text-field dense label="税号" outlined :rules="rules" v-model="editFormData.taxNo" />
                <v-text-field dense label="费用名称" outlined :rules="rules" v-model="editFormData.subjectName" />
                <v-text-field dense label="地址电话" outlined v-model="editFormData.addressTel" />
              </v-card-text>
            </v-card>
            <v-card outlined class="mt-4">
              <v-card-subtitle>收方信息</v-card-subtitle>
              <v-card-text>
                <v-text-field dense label="收方姓名" outlined :rules="rules" v-model="editFormData.rcvName" />
                <v-text-field dense label="收方联系电话" outlined :rules="rules" v-model="editFormData.rcvPhone" />
                <v-text-field dense label="收方地址" outlined :rules="rules" v-model="editFormData.rcvAddr" />
                <v-text-field dense label="收方邮编" outlined v-model="editFormData.rcvZipCode" />
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="editFlag=false">取消</v-btn>
          <v-btn color="primary" @click="onSave">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>
<script>
/* eslint-disable no-console */
import InvoiceDetail from './InvoiceDetail.vue'
import { getInvoiceList, deleteInvoice, setDefaultInvoice, saveInvoice } from '@/plugins/api'
import { required } from '@/plugins/rules'
export default {
  props: ['editable'],
  components: { InvoiceDetail },
  data () {
    return {
      loading: true,
      dataList: [],
      editFlag: false,
      editFormData: null,
      rules: [required()]
    }
  },
  methods: {
    onLoadData () {
      this.loading = true
      getInvoiceList().then(res => this.dataList = res.data || []).finally(() => this.loading = false)
    },
    onAdd () {
      this.editFlag = true
      this.editFormData = {}
    },
    onEdit (row) {
      this.editFormData = { ...row }
      this.editFlag = true
    },
    onDelete (row) {
      this.$message.confirm('确定删除吗?', () => {
        deleteInvoice(row.id).then(() => {
          this.$message.success()
          this.onLoadData()
        })
      })
    },
    onSetDefault (row) {
      setDefaultInvoice(row.id).then(() => {
        this.$message.success()
        this.onLoadData()
      })
    },
    onSave () {
      if (!this.$refs.editForm.validate()) return
      saveInvoice(this.editFormData).then((res) => {
        this.$message.success()
        this.editFlag = false
        let odrSrId = this.$route.query && this.$route.query.odrSrId
        if (odrSrId) this.$router.replace(`/profile/point/order?odrSrId=${odrSrId}&odrIvcId=${res.data.id}`)
        else this.onLoadData()
      })
    }
  },
  created () {
    this.onLoadData()
  }
}
</script>